export default "__VITE_ASSET__Bdx0IQQ9__"